export default "__VITE_ASSET__0737145f__"